import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'

import index from '@/components/page/index.vue' //首页
import About from '@/components/page/about.vue' //关于平台
import Options from '@/components/page/options.vue' //最新车源
import Services from '@/components/page/services.vue' //平台服务
import SupplyOfGoods from '@/components/page/supplyOfGoods.vue' //最新货源
import Enterprise from '@/components/page/enterprise.vue' //物流企业
import Charging from '@/components/page/charging.vue' //充电桩
import Energy from '@/components/page/energy.vue' //新能源车
import Active from '@/components/page/active.vue' //政策法规
import Information from '@/components/page/information.vue' // 行业服务详情
import Policy from '@/components/common/policy.vue' // 行业服务详情 子类
import Suggestion from '@/components/page/suggestion.vue' //建议
import Complaints from '@/components/page/complaints.vue' //投诉  carFindGood
import CarFindGood from '@/components/page/carFindGood.vue' //车找货
import GoodFindCar from '@/components/page/goodFindCar.vue' //货找车 、、
import Distribution from '@/components/page/distribution.vue' // 末端配送站
import ActiveInf from '@/components/page/activeInf.vue'  //政策法规 详情
import Industry from '@/components/page/industry.vue' //行业服务 子类
import Dynamic from '@/components/page/dynamic.vue' //行业管理动态
import Project from '@/components/page/project.vue' //物流项目建设
import Mien from '@/components/page/mien.vue' //企业风采
import Appraisal from '@/components/page/appraisal.vue' //绩效考核
import Station from '@/components/page/station.vue' //绿色配送临时停靠点
import Warehousing from '@/components/page/warehousing.vue' //仓储资源
import Financial from '@/components/page/financial.vue' //金融服务
import Newest from '@/components/page/newest.vue' // 最新资讯

Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}


export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: Index,
    children: [{
        path: '/',
        name: 'index',
        component: index,
      },
      {
        path: '/about',
        name: 'About',
        component: About,
      },
      {
        path: '/options',
        name: 'Options',
        component: Options,
      },
      {
        path: '/services',
        name: 'Services',
        component: Services,
      },
      {
        path: '/supplyOfGoods',
        name: 'SupplyOfGoods',
        component: SupplyOfGoods,
      },
      {
        path: '/enterprise',
        name: 'Enterprise',
        component: Enterprise,
      }, {
        path: '/charging',
        name: 'Charging',
        component: Charging,
      }, {
        path: '/energy',
        name: 'Energy',
        component: Energy,
      }, {
        path: '/information',
        name: 'Information',
        component: Information,
      }, {
        path: '/suggestion',
        name: 'Suggestion',
        component: Suggestion,
      },
      {
        path: '/complaints',
        name: 'Complaints',
        component: Complaints,
      },
      {
        path: '/carFindGood',
        name: 'CarFindGood',
        component: CarFindGood,
      },
      {
        path: '/goodFindCar',
        name: 'GoodFindCar',
        component: GoodFindCar,
      },
      {
        path: '/distribution',
        name: 'Distribution',
        component: Distribution,
      },
      {
        path: '/activeInf',
        name: 'ActiveInf',
        component: ActiveInf,
      },
      {
        path: '/financial/:id/:parentId',
        name: 'Financial',
        component: Financial,
      },
      {
        path: '/warehousing',
        name: 'Warehousing',
        component: Warehousing,
      },
      {
        path: '/project/:id/:parentId',
        name: 'Project',
        component: Project,
      },
      {
        path: '/dynamic/:id/:parentId',
        name: 'Dynamic',
        component: Dynamic,
      },
      {
        path: '/industry/:id/:parentId',
        name: 'Industry',
        component: Industry
      },
      {
        path: '/mien/:parentId',
        name: 'Mien',
        component: Mien
      },
      {
        path: '/appraisal',
        name: 'Appraisal',
        component: Appraisal
      },
      {
        path: '/station',
        name: 'Station',
        component: Station
      },
      {
        path: '/active/:id/:parentId',
        name: 'Active',
        component: Active,
        // children: [{
        //   path: '/',
        //   name: 'Policy',
        //   component: Policy
        // }, ]
      }
      ,
      {
        path: '/newest/:id/:parentId',
        name: 'Newest',
        component: Newest
      }
    ]
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js